import { SidenavBaseFilterComponent } from '../../../../../core/base/components/sidenav/base-filter/sidenav-base-filter.component';
import { PRESTATION_FILTER_SCHEMA } from './prestation-filter.schema';
import { AutocompleteService } from '../../../../../core/services/scroll.service';
import { AuthService } from '../../../../../core/services/auth.service';
import { SnackbarService } from '../../../../../core/services/snackbar.service';
import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SupplierService } from '../../supplier/supplier.service';
import { PrestationService } from '../prestation.service';
import { GenericPrestationService } from '../../../settings/generic-prestation/generic-prestation.service';

@Component({
  selector: 'prestation-filter',
  templateUrl: './prestation-filter.component.html',
  styleUrls: ['./prestation-filter.component.scss'],
})
export class PrestationFilterComponent extends SidenavBaseFilterComponent {
  override readonly schema = PRESTATION_FILTER_SCHEMA;
  // Champs (et non options inline dans le template) : la restauration retrouve l'objet d'option par référence
  purchaseUnitOptions = [
    { label: 'Interventions', value: 'Intervention' },
    { label: 'Heures', value: 'Heure' },
  ];
  suspensionOptions = [
    { label: 'Oui', value: true },
    { label: 'Non', value: false },
  ];

  constructor(
    public authService: AuthService,
    public snackbarService: SnackbarService,
    public autocompleteService: AutocompleteService,
    public supplierService: SupplierService,
    public genericPrestations: GenericPrestationService,
    public prestationService: PrestationService,
  ) {
    super(snackbarService, autocompleteService);

    this.addForm(
      'standardForm',
      new UntypedFormGroup({
        technicalIdentifier: new UntypedFormControl(),
        reference: new UntypedFormControl(),
        genericPrestations: new UntypedFormControl(),
        suppliers: new UntypedFormControl(),
        labels: new UntypedFormControl(),
        purchaseUnit: new UntypedFormControl(),
        isSuspended: new UntypedFormControl(),
      }),
    );
  }

  initialize() {
    this.autocompleteSuppliers();
    this.autocompleteGenericPrestations();
    this.autocompletePrestationFields('', 'label');
  }

  autocompleteSuppliers(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'suppliers', '_id', pageToGo, (page, size) =>
        this.supplierService.findAll(page, size, 'label', 'desc', search, {
          requiredFields: ['label'],
        }),
      )
      ?.subscribe();
  }

  autocompleteGenericPrestations(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'genericPrestations', '_id', pageToGo, (page, size) =>
        this.genericPrestations.findAll(page, size, 'label', 'desc', search, {
          requiredFields: ['label'],
        }),
      )
      ?.subscribe();
  }

  autocompletePrestationFields(search: string = '', filterName: string, pageToGo?: 'next' | 'previous') {
    const data = this.autocompleteService.autocompleteInfiniteScroll(
      search,
      filterName,
      filterName,
      pageToGo,
      (page, size) =>
        this.prestationService.findAll(page, size, filterName, 'desc', search, {
          onlyDistinctField: filterName,
          requiredFields: [filterName],
        }),
    );

    data.subscribe();
  }

  onScrollLine(pageToGo: 'next' | 'previous', filterField: string) {
    switch (filterField) {
      case 'genericPrestations':
        this.autocompleteGenericPrestations('', pageToGo);
        break;
      case 'suppliers':
        this.autocompleteSuppliers('', pageToGo);
        break;
      case 'label':
        this.autocompletePrestationFields('', filterField, pageToGo);
        break;
      default:
        console.error('Unknown filterField:', filterField);
    }
  }
}
